/* Poplar Bluff Trailer — global behavior: color scheme toggle + mobile nav */
(function () {
  'use strict';

  /* ---- Color scheme toggle (persists to localStorage) ---- */
  function applyTheme(mode) {
    document.documentElement.classList.toggle('dark', mode === 'dark');
    try { localStorage.setItem('pbt-theme', mode); } catch (e) {}
    document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
      var label = btn.querySelector('.label');
      if (label) label.textContent = mode === 'dark' ? 'Light' : 'Dark';
      btn.setAttribute('aria-pressed', String(mode === 'dark'));
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-theme-toggle]');
    if (!toggle) return;
    var next = document.documentElement.classList.contains('dark') ? 'light' : 'dark';
    applyTheme(next);
  });

  /* Sync toggle labels on load with the class set by the inline head script */
  applyTheme(document.documentElement.classList.contains('dark') ? 'dark' : 'light');

  /* ---- Mobile menu ---- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-menu-open]');
    var close = e.target.closest('[data-menu-close]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!menu) return;
    if (open) { menu.classList.add('open'); document.body.style.overflow = 'hidden'; }
    if (close || e.target === menu) { menu.classList.remove('open'); document.body.style.overflow = ''; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var menu = document.querySelector('[data-mobile-menu].open');
    if (menu) { menu.classList.remove('open'); document.body.style.overflow = ''; }
  });
})();
